import { useTranslation } from 'react-i18next';
import { useModal } from 'Store/modal';

const useCancelRescheduleModal = () => {
  const { t } = useTranslation('host-reschedule');
  const { onOpenModal } = useModal();

  const onOpenModalCancelReschedule = (mutate) => {
    onOpenModal({
      width: 'calc(100vw - 24px)',
      maxWidth: 'calc(100vw - 24px)',
      isOpen: true,
      type: 'cancel',
      title: t('confirm_cancel.title'),
      contentDescription: t('confirm_cancel.description'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('common:yes_cancel'),
      secondaryButtonText: t('common:close'),
      onClickPrimaryButton: () => {
        mutate();
      },
    });
  };

  return { onOpenModalCancelReschedule };
};

export default useCancelRescheduleModal;
